import { render } from "./showTip.vue?vue&type=template&id=7c229b72&scoped=true&lang=pug"
import script from "./showTip.vue?vue&type=script&setup=true&lang=js"
export * from "./showTip.vue?vue&type=script&setup=true&lang=js"

import "./showTip.vue?vue&type=style&index=0&id=7c229b72&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c229b72"]])

export default __exports__